<div [ngClass]="{ 'ui-logo-apac': baseSite === 'APAC' }" class="container CountrySelectorSiteLogo">
  <cx-page-slot position="SiteLogo"></cx-page-slot>
</div>

<div class="country-selector-dd container">
  <div class="country-top-block">
    <h1> {{'common.text_select_country'|cxTranslate}}</h1>
  </div>
  @if (countrySelectorData$|async; as countrySelectorData) {
    <div class="country-bottom-block">
      <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-12">
          <div class="master-country grid-NA row">
            <div class="col-sm-12 col-md-6 col-lg-6">
              @if (countrySelectorData?.baseStoreWSListNa) {
                <div class="condition-1">
                  <div class="country-selector-Title">
                    {{'common.text_select_master_country_na'|cxTranslate}}
                  </div>
                  @for (store of countrySelectorData.baseStoreWSListNa; track store) {
                    <div class="row">
                      <div class="col-xs-4 col-sm-6 col-md-6 col-lg-4 country-select">
                        {{ store.name }}
                      </div>
                      <div class="col-xs-8 col-sm-6 col-md-6 col-lg-8 lang-select">
                        @for (language of store.languages; track language; let last = $last) {
                          <span>
                            <a [href]="getHrefLink(store.uid, language.isocode,store.defaultCurrency.isocode,store.countryIsoCode,store.siteUid)"
                        (click)="generateHrefLink(
                        language.isocode, store.defaultCurrency.isocode, store.countryIsoCode,language.displayIsoCode,
                        store.media.url, store.siteUid, $event)">
                              {{ language.name}}
                            </a>
                            @if (!last) {
                              <span class="seprator-ui"> | </span>
                            }
                          </span>
                        }
                      </div>
                    </div>
                  }
                </div>
              }
              @if (countrySelectorData?.baseStoreWSListMena) {
                <div class="condition-4 mt-4">
                  <div class="country-selector-Title">
                    {{'common.text_select_master_country_africa'|cxTranslate}}
                  </div>
                  @for (store of countrySelectorData.baseStoreWSListMena; track store) {
                    <div class="row">
                      <div class="col-xs-4 col-sm-6 col-md-6 col-lg-4 country-select">
                        {{ store.name }}
                      </div>
                      <div class="col-xs-8 col-sm-6 col-md-6 col-lg-8 lang-select">
                        @for (language of store.languages; track language; let last = $last) {
                          <span>
                            <a [href]="getHrefLink(store.uid, language.isocode,store.defaultCurrency.isocode,store.countryIsoCode,store.siteUid)"
                        (click)="generateHrefLink(language.isocode, store.defaultCurrency.isocode, store.countryIsoCode,language.displayIsoCode,
                      store.media.url, store.siteUid, $event)">
                              {{ language.name }}
                            </a>
                            @if (!last) {
                              <span> | </span>
                            }
                          </span>
                        }
                      </div>
                    </div>
                  }
                </div>
              }
              @if (countrySelectorData?.baseStoreWSListFot) {
                <div class="condition-3 mt-4">
                  <div class="country-selector-Title">
                    {{'common.text_select_master_country_frenchoverseas'|cxTranslate}}
                  </div>
                  @for (store of countrySelectorData.baseStoreWSListFot; track store) {
                    <div class="row">
                      <div class="col-xs-4 col-sm-6 col-md-6 col-lg-4 country-select">
                        {{ store.name }}
                      </div>
                      <div class="col-xs-8 col-sm-6 col-md-6 col-lg-8 lang-select">
                        @for (language of store.languages; track language; let last = $last) {
                          <span>
                            <a [href]="getHrefLink(store.uid, language.isocode,store.defaultCurrency.isocode,store.countryIsoCode,store.siteUid)"
                        (click)="generateHrefLink(language.isocode, store.defaultCurrency.isocode, store.countryIsoCode,language.displayIsoCode,
                      store.media.url, store.siteUid, $event)">
                              {{ language.name}}
                            </a>
                            @if (!last) {
                              <span class="seprator-ui"> | </span>
                            }
                          </span>
                        }
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
            <div class="col-sm-12 col-md-6 col-lg-6 ">
              @if (countrySelectorData?.baseStoreWSListApac) {
                <div class="condition-4">
                  <div class="country-selector-Title">
                    {{'common.text_select_master_country_asia'|cxTranslate}}
                  </div>
                  @for (store of countrySelectorData.baseStoreWSListApac; track store) {
                    <div class="row">
                      <div class="col-xs-4 col-sm-6 col-md-6 col-lg-4 country-select">
                        {{ store.name }}
                      </div>
                      <div class="col-xs-8 col-sm-6 col-md-6 col-lg-8 lang-select">
                        @for (language of store.languages; track language; let last = $last) {
                          <span>
                            <a [href]="getHrefLink(store.uid, language.isocode,store.defaultCurrency.isocode,store.countryIsoCode,store.siteUid)"
                        (click)="generateHrefLink(
                        language.isocode, store.defaultCurrency.isocode, store.countryIsoCode,language.displayIsoCode,
                        store.media.url, store.siteUid, $event)">
                              {{ language.name}}
                            </a>
                            @if (!last) {
                              <span class="seprator-ui"> | </span>
                            }
                          </span>
                        }
                      </div>
                    </div>
                  }
                </div>
              }
              @if (countrySelectorData?.baseStoreWSListEmea) {
                <div class="condition-5 mt-4">
                  <div class="country-selector-Title">
                    {{'common.text_select_master_country_europe'|cxTranslate}}
                  </div>
                  @for (store of countrySelectorData.baseStoreWSListEmea; track store) {
                    <div class="row">
                      <div class="col-xs-4 col-sm-6 col-md-6 col-lg-4 country-select">
                        {{ store.name }}
                      </div>
                      <div class="col-xs-8 col-sm-6 col-md-6 col-lg-8 lang-select">
                        @for (language of store.languages; track language; let last = $last) {
                          <span>
                            <a [href]="getHrefLink(store.uid, language.isocode,store.defaultCurrency.isocode,store.countryIsoCode,store.siteUid)"
                        (click)="generateHrefLink(
                      language.isocode, store.defaultCurrency.isocode, store.countryIsoCode,language.displayIsoCode,
                      store.media.url, store.siteUid, $event)">
                            {{ language.name }}</a>
                            @if (!last) {
                              <span class="seprator-ui"> | </span>
                            }
                          </span>
                        }
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  }
</div>